import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Image from "../../elements/image";
import SuperButton from "../../elements/super-button";
import Heading from "../../elements/heading";

export default class LargeImageContent extends Component {
  getButton(button) {
    let buttonvalue = button.fields,
      buttontype =
        buttonvalue && buttonvalue.ctatype
          ? buttonvalue.ctatype.fields.phrase.value
          : "icon-link";
    if (buttonvalue) buttonvalue.defaultType = buttontype;
    return <SuperButton {...buttonvalue} />;
  }

  largeImageContentContent(fields) {
    const { rendering } = this.props;
    const {
      paddingAboveTop,
      paddingAboveBottom,
      gridType,
      backgroundColor,
      order,
      headingType,
      headingBody,
      image,
      items
    } = fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom
        ? paddingAboveBottom.fields.phrase.value
        : "default";
    const largeImageContentClasses = classNames(
        "padding-top-" + top,
        "padding-bottom-" + bottom,
        "large-image-content",
        gridType && gridType.fields.phrase.value === "story"
          ? "grid-story"
          : "grid",
        {
          mirrored: order && order.fields.phrase.value === "reverse"
        }
      ),
      mediaClasses = classNames("media", {
        placeholder: !image.value.src,
        mirrored: order && order.fields.phrase.value === "reverse"
      }),
      itemsClasses = classNames("items", {
        mirrored: order && order.fields.phrase.value === "reverse"
      });
    let backgroundStyle = {
      background: backgroundColor
        ? backgroundColor.fields.phrase.value
        : "transparent"
    };
    return (
      <div
        className={largeImageContentClasses}
        datasourceid={rendering.dataSource}
        style={backgroundStyle}
      >
        {headingBody.value && (
          <Heading
            {...{ type: headingType, html: headingBody }}
            className={"title show-on-scroll"}
          />
        )}
        <div className={mediaClasses}>
          {image.value.src && <Image {...image.value} />}
        </div>
        <div className={itemsClasses}>
          {items &&
            items.map((item, index) => {
              return (
                <div key={index}>
                  <Heading
                    type={item.fields.headingType}
                    className={"title"}
                    html={item.fields.headingBody}
                  />
                  <RichText
                    tag="div"
                    className={"body"}
                    field={item.fields.body}
                  />
                  {item.fields.button && (
                    <div className={"cta"}>
                      {this.getButton(item.fields.button)}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    const { fields } = this.props;
    const { gridType } = fields;
    if (gridType && gridType.fields.phrase.value === "story") {
      return (
        <div className={"grid"}>{this.largeImageContentContent(fields)}</div>
      );
    } else {
      return this.largeImageContentContent(fields);
    }
  }
}
